import { useState, useEffect } from "react";
import { Formik } from "formik";
import { Switch } from "@material-ui/core";
import { Form, Col, Row } from "react-bootstrap";
import { Authorities, CustomSelect } from "../../../../../../_helpers/Helpers";

export function ModuleEditForm({ 
  module,
  parentModuleOptions,
  btnRef,
  saveModule
}) {
  const [authorityIds, setAuthorityIds] = useState([]);

  useEffect(() => {
    setAuthorityIds(module.authorityIds.map(m => m.toString()));
  }, [module.authorityIds]);
  
  return (
    <Formik
      enableReinitialize={true}
      initialValues={module}
      onSubmit={(values) => {
        const module = {
          id: values.id,
          parentId: values.parentId,
          name: values.name,
          key: values.key,
          icon: values.icon,
          link: values.link,
          order: values.order === "" ? 0 : values.order,
          isInLeftMenu: values.isInLeftMenu,
          authorityIds: authorityIds
        };
        saveModule(module);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="parentModule">
            <Form.Label column sm={2}>
              Ana Modül
            </Form.Label>
            <Col sm={10}>
              <CustomSelect 
                options={parentModuleOptions}
                value={values.parentId}
                onChange={option => setFieldValue("parentId", option.value)}
              />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Adı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="key">
            <Form.Label column sm={2}>
              Anahtarı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.key} placeholder="Anahtarı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="icon">
            <Form.Label column sm={2}>
              İkonu
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.icon} placeholder="İkonu" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="link">
            <Form.Label column sm={2}>
              Link
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.link} placeholder="Link" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="order">
            <Form.Label column sm={2}>
              Sırası<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="number" value={values.order} placeholder="Sırası" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="isInLeftMenu">
            <Form.Label column sm={2}>
              Yan Menüde mi
            </Form.Label>
            <Col sm={10}>
              <Switch checked={values.isInLeftMenu} onChange={handleChange("isInLeftMenu")} />
            </Col>
          </Form.Group>
                    
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Yetkileri
            </Form.Label>
            <Col sm={10} className="mt-3">
              <Form.Check 
                inline
                type="checkbox"
                className="mr-3"
                label="Tümü"
                onChange={e => setAuthorityIds(e.target.checked ? Authorities.map(authority => authority.id.toString()) : [])}
              />
              {
                Authorities.map(authority => (
                  <Form.Check 
                    inline
                    type="checkbox"
                    className="mr-3"
                    key={authority.name}
                    value={authority.id}
                    label={authority.definition}
                    checked={authorityIds.includes(authority.id.toString())}
                    onChange={e => {
                      const value = e.target.value;
                      setAuthorityIds(ids => ids.includes(value) ? ids.filter(id => id !== value) : [...ids, value]);
                    }}
                  />
                ))
              }                
            </Col>
          </Form.Group>
          
          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          />
        </Form>
      )}          
    </Formik>
  );
}